module.exports = __webpack_public_path__ + "static/18-ffb74aabfc6415c05f1e9b361eaa5702.jpg";